import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import CountrySpecific from '../../../../../common/country-specific/country-specific';
import CustomLink from '../../../../../common/custom-link';
import WorldSwitch from '../../../../../common/world-switch/world-switch';
import { helpCenter } from '../../../../../constants/contact-data';
import ROUTES from '../../../../../constants/routes';
import { ReactComponent as ContactSupport } from '../../../../../images/header/contact-support.svg';
import translation, { world } from '../../../../../languages';
import { AVAILABLE_WORLDS } from '../../../../../languages/constants';
import analytics from '../../../../../services/analytics';
import cn from '../../../../../utils/classnames';
import { domainLinkCreator } from '../../../../../utils/domain-manager';
import './extra.scss';

type ExtraPropsType = TranslationProps & {
    myMaterialsLink: string;
};

const Extra: FC<ExtraPropsType> = ({ myMaterialsLink, t }) => {
    const isActiveNavigationAbTest = useSelector(
        (state: RootState) => state.main.schoolClassification.isActiveNavigationAbTest
    );
    const onSchoolClick = () => {
        analytics.push({
            event: 'gtmEvent',
            eventAction: 'NewSchoolLinkClicked',
            eventCategory: 'mkt-userInteraction',
            eventNonInteraction: false
        });
    };

    return (
        <div
            id={isActiveNavigationAbTest ? 'simplified-navbar' : undefined}
            className={cn('extra', { 'simplified-navigation': isActiveNavigationAbTest })}
        >
            <div className='container d-flex align-items-center justify-content-end'>
                {isActiveNavigationAbTest ? (
                    <div id='extra-navigation-buttons' className='extra-navigation-buttons'>
                        <Link id='extra-upload' className='link tsc-caption' to={myMaterialsLink}>
                            {t('header.icons.upload')}
                        </Link>
                        <CountrySpecific allowed={[AVAILABLE_WORLDS.DE]}>
                            <CustomLink
                                exact
                                id='extra-schulaccounts'
                                onClick={onSchoolClick}
                                className='link tsc-caption'
                                to={domainLinkCreator(ROUTES.SCHOOL_ACCOUNT.path)}
                            >
                                Schulaccounts
                            </CustomLink>
                        </CountrySpecific>
                        <a
                            id='extra-help-center'
                            className='link tsc-caption'
                            href={domainLinkCreator(helpCenter[world])}
                        >
                            <ContactSupport />
                        </a>
                        <WorldSwitch asIcon />
                    </div>
                ) : (
                    <>
                        <WorldSwitch asIcon />
                        <a className='link tsc-caption' href={`/${world}/id/1236/eduki`}>
                            {t('header.extra.about')}
                        </a>
                        <Link className='link tsc-caption' to={ROUTES.HELP_CENTER.path}>
                            {t('header.extra.helpCenter')}
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

const translate = translation('header');

export default translate(Extra);
